// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__rYXYu","container":"Footer_container__jMb-s","links":"Footer_links__FH6Qf","copyright":"Footer_copyright__EJ7qD","attribution":"Footer_attribution__B0VLa"};